<template>
  <PageHeader
    title="Create new report"
    subtitle="Create a comprehensive stormwater management report"
    :back-route="{ name: 'reports' }"
  >
    <AppButton v-if="enableAutofill" variant="primary" @click="autofill">Autofill</AppButton>
  </PageHeader>
</template>

<script setup>
import { AppButton } from "@/components/ui";
import PageHeader from "@/components/PageHeader.vue";

const emit = defineEmits(["autofill"]);

const enableAutofill = import.meta.env.VITE_ENABLE_AUTOFILL === "true";

const autofill = () => {
  emit("autofill");
};
</script>
